import * as React from 'react';
import { DELTA, GENERAL, PROFILE, RESULTS } from '../../store/constants';
import ProfileContainer from './content/profile/ProfileContainer';
import GeneralContainer from './content/general/GeneralContainer';
import DeltaContainer from './content/delta/DeltaContainer';
import ResultsContainer from './content/results/ResultsContainer';

interface Props {
    loading: boolean;
    activeId: string;
}

function isActive(activeId: string, id: string) {
    return activeId === id;
}

class MainComponent extends React.Component<Props> {
    render() {
        const { activeId } = this.props;

        return (
            <div>
                { isActive(activeId, PROFILE) &&
                    <ProfileContainer />
                }
                { isActive(activeId, GENERAL) &&
                    <GeneralContainer />
                }
                { isActive(activeId, DELTA) &&
                    <DeltaContainer />
                }
                { isActive(activeId, RESULTS) &&
                    <ResultsContainer />
                }
            </div>
        );
    }
}

export default MainComponent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/MainComponent.tsx